

export function getScrollTimeOfWeek(calendarApi, events = []) {
  /*ScrollTime
    Retourne le scrollTime de la vue week en fontion de l'événement le plus tôt de la semaine
  */

  let eventInstanceDate
  const minHours =  events.reduce((min, event) => {
      eventInstanceDate = new Date(event.start)
      return (eventInstanceDate >= calendarApi.view.currentStart && eventInstanceDate <  calendarApi.view.currentEnd ? Math.min(min, eventInstanceDate.getHours()) : min)
  }, 24)
  
  console.log("getScrollTimeOfWeek", events.length ? `${String(minHours).padStart(2,'0')}:00:00` : "09:00:00",calendarApi.view.currentStart, calendarApi.view.currentEnd)
  return events.length && minHours < 24? `${String(minHours).padStart(2,'0')}:00:00` : "09:00:00"
}

export function formatLabelDateEvent(date) {
  if (date instanceof Date === false) {
      date = new Date(date)
  }

  return date.toLocaleTimeString('fr-FR', {
    hour: 'numeric',
    minute: 'numeric'
  }).replace(':','h');
  
}
